type SwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  id?: string;
  name?: string;
};

const Switch = ({
  checked,
  onCheckedChange,
  className,
  id,
  name,
}: SwitchProps) => {
  return (
    <div className="flex items-center" id={id}>
      <button
        type="button"
        role="switch"
        aria-checked="false"
        data-state={checked ? "checked" : "unchecked"}
        value="on"
        className={`peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=${
          checked ? "checked" : "unchecked"
        }]:bg-input`}
        id={id}
        onClick={() => onCheckedChange(!checked)}
      >
        <span
          data-state={checked ? "checked" : "unchecked"}
          className="pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        ></span>
      </button>
      <input
        aria-hidden="true"
        // tabindex="-1"
        type="checkbox"
        value="on"
        style={{
          transform: "translateX(-100%)",
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: "0px",
          width: "44px",
          height: "24px",
        }}
      />
      <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ml-2">
        {name}
      </label>
    </div>
  );
};

export { Switch };
